module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voteAdd"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("投票")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("创建项目")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vote-add-box"
  }, [_c('el-form', {
    ref: "addVoteForm",
    staticClass: "addVoteForm",
    attrs: {
      "model": _vm.addVoteForm,
      "rules": _vm.validateRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "vote_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写投票标题"
    },
    model: {
      value: (_vm.addVoteForm.vote_name),
      callback: function($$v) {
        _vm.addVoteForm.vote_name = $$v
      },
      expression: "addVoteForm.vote_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "prop": "vote_content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请填写投票描述"
    },
    model: {
      value: (_vm.addVoteForm.vote_content),
      callback: function($$v) {
        _vm.addVoteForm.vote_content = $$v
      },
      expression: "addVoteForm.vote_content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "焦点图",
      "prop": "bgimg"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写焦点图（尺寸2：1）链接"
    },
    model: {
      value: (_vm.addVoteForm.bgimg),
      callback: function($$v) {
        _vm.addVoteForm.bgimg = $$v
      },
      expression: "addVoteForm.bgimg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起止时间",
      "prop": "vote_start_end_time"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "placeholder": "选择时间范围",
      "align": "right"
    },
    model: {
      value: (_vm.addVoteForm.vote_start_end_time),
      callback: function($$v) {
        _vm.addVoteForm.vote_start_end_time = $$v
      },
      expression: "addVoteForm.vote_start_end_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is_share_box",
    attrs: {
      "label": "自定义分享",
      "prop": "is_share"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-color": "#13ce66",
      "off-color": "#ff4949",
      "on-value": "1",
      "off-value": "0"
    },
    on: {
      "change": _vm.changeIsShareFlag
    },
    model: {
      value: (_vm.addVoteForm.is_share),
      callback: function($$v) {
        _vm.addVoteForm.is_share = $$v
      },
      expression: "addVoteForm.is_share"
    }
  })], 1), _vm._v(" "), (_vm.addVoteForm.is_share === '1') ? [_c('el-form-item', {
    attrs: {
      "label": "分享标题",
      "prop": "share_title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写分享标题"
    },
    model: {
      value: (_vm.addVoteForm.share_title),
      callback: function($$v) {
        _vm.addVoteForm.share_title = $$v
      },
      expression: "addVoteForm.share_title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享描述",
      "prop": "share_content"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写分享描述"
    },
    model: {
      value: (_vm.addVoteForm.share_content),
      callback: function($$v) {
        _vm.addVoteForm.share_content = $$v
      },
      expression: "addVoteForm.share_content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享图",
      "prop": "share_img"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写分享图链接"
    },
    model: {
      value: (_vm.addVoteForm.share_img),
      callback: function($$v) {
        _vm.addVoteForm.share_img = $$v
      },
      expression: "addVoteForm.share_img"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addVote('addVoteForm')
      }
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.clearVoteData()
      }
    }
  }, [_vm._v("重置")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "vote-preview-box"
  }, [_c('div', {
    staticClass: "header-image"
  }, [(_vm.addVoteForm.bgimg) ? _c('img', {
    attrs: {
      "src": _vm.addVoteForm.bgimg
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.addVoteForm.vote_content !== null && _vm.addVoteForm.vote_content !== '') ? _c('div', {
    staticClass: "description"
  }, [_c('span', {
    staticClass: "desc-content"
  }, [_vm._v(_vm._s(_vm.addVoteForm.vote_content))])]) : _vm._e(), _vm._v(" "), _vm._m(0)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "go-list-btn"
  }, [_vm._v("查看排名")]), _vm._v(" "), _c('div', {
    staticClass: "option-list"
  }, [_c('img', {
    attrs: {
      "src": "http://tstatic.toptest.yidianzixun.com.ks3-cn-beijing.ksyun.com/public/files/demo1497505528343.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://tstatic.toptest.yidianzixun.com.ks3-cn-beijing.ksyun.com/public/files/demo1497505528343.png"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-e1f0b4e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/vote/Add.vue
// module id = 797
// module chunks = 1